// With this approach we do not need any changes to tsconfigs or webpack configs
// If ever the sw folder changes we need to change the path here too.
import { ONE_SECOND } from '@lucidlink/uicore';
// Time to activation might be a bit slow on the first file preview as browser
// has to download the service worker js file.
const DEFAULT_WAIT_TIME_FOR_ACTIVATION = 15 * ONE_SECOND;
// TODO: https://lucidlink.atlassian.net/browse/LUCID-22599
// Try to extract these functions as they're exact duplicates of the ones from file download
// it might not be possible as webpack is a bit finicky for some reason
export const startSWAndWaitOnActivate = async ({ activationPromise, scope, throwAfter = DEFAULT_WAIT_TIME_FOR_ACTIVATION, }) => {
    let throwTimeout;
    let serviceWorkerRegistration;
    // eslint-disable-next-line no-useless-catch -- Not useless, will rethrow different error type
    try {
        serviceWorkerRegistration = await navigator.serviceWorker.register(
        // Follow the requirements for this type of URL to work - https://webpack.js.org/guides/web-workers/
        // Do not save the URL into a const, do not save 'navigator.serviceWorker' in a const
        new URL('../service-worker/file-preview-sw.ts', import.meta.url), { scope });
    }
    catch (error) {
        // TODO: throw a custom error type
        throw error;
    }
    return Promise.race([
        new Promise((_, reject) => {
            throwTimeout = window.setTimeout(() => {
                // TODO: throw a custom error type
                // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors -- preserve the existing string rejection (behavior-neutral migration); no caller inspects an Error type here
                reject('Service Worker did not respond in time');
            }, throwAfter);
        }),
        new Promise((resolve) => {
            activationPromise
                .then(() => {
                clearTimeout(throwTimeout);
                resolve(serviceWorkerRegistration);
            })
                // eslint-disable-next-line no-restricted-syntax -- Cannot use async inside new Promise handlers
                .catch((error) => {
                // In the current Provider implementation, this Promise
                // cannot throw, but to be safe, catch and rethrow so
                // that functions calling this function can catch the error
                // TODO: Throw a custom error type
                throw error;
            });
        }),
    ]);
};
